export default __webpack_public_path__ + "static/media/three-dots.afdce36d.svg";